// extracted by mini-css-extract-plugin
export var container = "_61-1";
export var editor = "_61-2";
export var resizable = "_61-3";
export var wrapper = "_61-0";